// driver api
import listTermsApi from '@drivesally/sally-fn/lib/driver/api/listTos.api.driver';

// react
import React, {Component} from 'react';

// propTypes
import PropTypes from 'prop-types';

// redux
import {connect} from 'react-redux';

// termsOfService actions
import {set as setAct} from '../../redux/actions';

// components
import {FullScreenLoader} from '@drivesally/sally-ui';

// error
import parseError from '../../../error/parseError';

// lib
import {lib} from '@drivesally/sally-ui';

// alerts
const {alert} = lib;

class LatestTosContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    dispatch: PropTypes.func,
  };

  state = {
    initialized: false,
  };

  componentDidMount() {
    this.init();
  }

  init = async () => {
    const {dispatch} = this.props;
    try {
      const {results} = await listTermsApi({ordering: '-created_at', limit: 1});
      const latestTos = results?.[0] || null;
      dispatch(setAct({latestTos}));
      this.setState({initialized: true});
    } catch (error) {
      const {message} = parseError(error);
      alert.error(message);
      alert.info('Refresh');
    }
  };

  render() {
    const {children} = this.props;
    const {initialized} = this.state;
    return initialized ? children : <FullScreenLoader />;
  }
}

export default connect()(LatestTosContainer);
